var globalPrefix = '';
var containerPrefix;
var rowPrefix;
var columnPrefix;
var PrefixManager = /** @class */ (function () {
    function PrefixManager() {
    }
    Object.defineProperty(PrefixManager.prototype, "global", {
        get: function () {
            return globalPrefix;
        },
        set: function (prefix) {
            globalPrefix = prefix;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrefixManager.prototype, "container", {
        get: function () {
            return containerPrefix || globalPrefix;
        },
        set: function (prefix) {
            containerPrefix = prefix;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrefixManager.prototype, "row", {
        get: function () {
            return rowPrefix || globalPrefix;
        },
        set: function (prefix) {
            rowPrefix = prefix;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrefixManager.prototype, "column", {
        get: function () {
            return columnPrefix || globalPrefix;
        },
        set: function (prefix) {
            columnPrefix = prefix;
        },
        enumerable: true,
        configurable: true
    });
    return PrefixManager;
}());
export default new PrefixManager();
//# sourceMappingURL=PrefixManager.js.map